module.exports = __webpack_public_path__ + "assets/img/ellipses.ecafbf6a.png";